module.exports = __webpack_public_path__ + "assets/img/fa4f1fd0b171eb0228c5e826bee37e32.png";